
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6866',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6866",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8470",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11924",
  "I18n": "static-7.1698",
  "jasmine-runner": "static-1.6883",
  "quartz": "static-1.7608",
  "quartz-core": "static-1.6827",
  "react-dlb": "static-1.92",
  "reselect": "static-3.15",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.1054",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8678",
  "hub-http": "static-1.6641",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12231",
  "icons": "static-2.699",
  "immer": "static-1.104",
  "laboratory-lib": "static-3.7582",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1386",
  "quartz-routing": "static-1.1038",
  "quick-fetch": "static-1.4204",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17166",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5636",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "redux-toolkit": "static-1.81",
  "signup-constants": "static-1.19861",
  "signup-ui-lego-core": "static-1.21871",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.514",
  "ui-addon-react-router-dom": "static-1.9961",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8870",
  "usage-tracker": "static-1.7746",
  "usage-tracker-core": "static-1.7596",
  "viral-links-lib": "static-1.7512",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3885",
  "quartz-webpack": "static-1.3832",
  "bend-plugin-quartz-routing": "static-1.686",
  "HeadJS": "static-2.816",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3581",
  "msw": "static-1.102",
  "msw-config": "static-1.24",
  "testing-library": "static-1.163",
  "foundations-theming": "static-1.4915",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4740",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.901",
  "hubspotter-http": "static-1.4946",
  "mobile-manifest-mixins": "static-1.599",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.594",
  "quartz-auth": "static-1.1283",
  "quartz-head": "static-1.1273",
  "quartz-i18n": "static-1.1283",
  "quartz-test": "static-1.1283",
  "quartz-tracking": "static-1.987",
  "trellis-components": "static-1.3010",
  "ui-fonts": "static-1.1186",
  "usage-tracker-container": "static-1.7736",
  "sassPrefix": "static-1.322",
  "bend-plugin-foundations-components": "static-1.4947",
  "floating-ui": "static-1.67",
  "foundations-assets": "static-1.5318",
  "foundations-theming-specialty": "static-1.2631",
  "hs-story-utils": "static-1.9857",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.96",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2991",
  "hs-locale-management": "static-1.374",
  "superstore": "static-1.5190",
  "opentelemetry-fe-types": "static-1.219",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "rpc-client-utils": "static-1.5103",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.3318",
  "signup-ui-url-generator": "static-2.8491",
  "bender-build-tools": "static-1.3518",
  "bend-plugin-foundations-theming": "static-1.3398",
  "foundations-theming-base": "static-1.3900",
  "stylex": "static-1.45",
  "beacon-keepalive-queue": "static-1.132",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10831",
  "hubspotter-http-shared-msw-handlers": "static-1.10829",
  "usage-tracker-session-replay": "static-1.5432",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1419",
  "tanstack-virtual": "static-1.42",
  "stylex-utils": "static-1.166",
  "bend-plugin-chirp-manifest": "static-1.513",
  "chirp-fetch": "static-1.2334",
  "ts-schema": "static-1.4374",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6866",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8470",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11924",
  "I18n": "/I18n/static-7.1698",
  "jasmine-runner": "/jasmine-runner/static-1.6883",
  "quartz": "/quartz/static-1.7608",
  "quartz-core": "/quartz-core/static-1.6827",
  "react-dlb": "/react-dlb/static-1.92",
  "reselect": "/reselect/static-3.15",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.1054",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8678",
  "hub-http": "/hub-http/static-1.6641",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12231",
  "icons": "/icons/static-2.699",
  "immer": "/immer/static-1.104",
  "laboratory-lib": "/laboratory-lib/static-3.7582",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1386",
  "quartz-routing": "/quartz-routing/static-1.1038",
  "quick-fetch": "/quick-fetch/static-1.4204",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17166",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5636",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "signup-constants": "/signup-constants/static-1.19861",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.21871",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9961",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8870",
  "usage-tracker": "/usage-tracker/static-1.7746",
  "usage-tracker-core": "/usage-tracker-core/static-1.7596",
  "viral-links-lib": "/viral-links-lib/static-1.7512",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3885",
  "quartz-webpack": "/quartz-webpack/static-1.3832",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.686",
  "HeadJS": "/HeadJS/static-2.816",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3581",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.24",
  "testing-library": "/testing-library/static-1.163",
  "foundations-theming": "/foundations-theming/static-1.4915",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4740",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.901",
  "hubspotter-http": "/hubspotter-http/static-1.4946",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.599",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.594",
  "quartz-auth": "/quartz-auth/static-1.1283",
  "quartz-head": "/quartz-head/static-1.1273",
  "quartz-i18n": "/quartz-i18n/static-1.1283",
  "quartz-test": "/quartz-test/static-1.1283",
  "quartz-tracking": "/quartz-tracking/static-1.987",
  "trellis-components": "/trellis-components/static-1.3010",
  "ui-fonts": "/ui-fonts/static-1.1186",
  "usage-tracker-container": "/usage-tracker-container/static-1.7736",
  "sassPrefix": "/sassPrefix/static-1.322",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4947",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-assets": "/foundations-assets/static-1.5318",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2631",
  "hs-story-utils": "/hs-story-utils/static-1.9857",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.96",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2991",
  "hs-locale-management": "/hs-locale-management/static-1.374",
  "superstore": "/superstore/static-1.5190",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.219",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "rpc-client-utils": "/rpc-client-utils/static-1.5103",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.3318",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8491",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3398",
  "foundations-theming-base": "/foundations-theming-base/static-1.3900",
  "stylex": "/stylex/static-1.45",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.132",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10831",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10829",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5432",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1419",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "stylex-utils": "/stylex-utils/static-1.166",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.513",
  "chirp-fetch": "/chirp-fetch/static-1.2334",
  "ts-schema": "/ts-schema/static-1.4374",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
